import React, { useEffect, useState, useRef } from "react";
import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Row,
    Col,
} from "reactstrap";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";

import {
    getCompanies as onGetCompanies,
    getDataDashboard as OnGetDataDashboard,
    getPeriods as onGetPeriods,
    clearDasborData as onClearDasborData
} from '../../store/actions'
import PulseLoader from "react-spinners/PulseLoader";

const Filter = () => {
    const dispatch = useDispatch();

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e);
    }

    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [optionPeriod, setOptionPeriod] = useState([]);
    function handleSelectPeriod(e) {
        setSelectedPeriod(e);
    }

    const { companies, loadingCompany, loading, periods, loadingPeriod } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        loading: state.Dashboard.loading,
        periods: state.Period.periods,
        loadingPeriod: state.Period.loading
    }));

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map((item) => {
                return { label: item.name, value: item.id }
            }))
        }
    }, [periods])

    var filterPeriod = useRef(null)

    const onRefreshCommand = () => {
        if (selectedCompany && selectedPeriod) {
            dispatch(OnGetDataDashboard({ companyId: selectedCompany.value, periodId: selectedPeriod.value }));
        }
    }

    useEffect(() => {
        if (dispatch) {
            dispatch(onGetCompanies({}));
        }
    }, [dispatch])

    useEffect(() => {
        dispatch(onClearDasborData())
        if (selectedCompany) {
            filterPeriod.current?.value?.clear();
            setSelectedPeriod(null)
            dispatch(onGetPeriods({ companyId: selectedCompany.value }))
        }
    }, [selectedCompany])

    return <Card>
        <CardBody>
            <CardTitle>Company</CardTitle>
            <Row>
                <Col sm={6}>
                    <div>
                        <Select
                            value={selectedCompany}
                            onChange={handleSelectCompany}
                            options={optionCompany}
                            isLoading={loadingCompany}
                            isClearable={false}
                            className="select2-selection"
                            menuPosition="fixed"
                        />
                    </div>
                </Col>
                <Col sm={4}>
                    <div>
                        <Select
                            value={selectedPeriod}
                            onChange={handleSelectPeriod}
                            options={optionPeriod}
                            isLoading={loadingPeriod}
                            className="select2-selection"
                            menuPosition="fixed"
                            isClearable={true}
                            ref={filterPeriod}
                        />
                    </div>
                </Col>
                <Col className="col-12 col-sm-2">
                    <Button className="btn btn-primary align-self-bottom" color="primary" block={true} onClick={onRefreshCommand}>
                        {loading && <PulseLoader loading={loading} color={'#FFF'} size={8} className="align-self-center" />}
                        {!loading && <i className="bx bx-filter-alt"></i>}
                    </Button>
                </Col>
            </Row>
        </CardBody>
    </Card>
}

export default Filter;